// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Agcx","productName":"Table_productName__1FZhZ"};